import { toRequestCurrency } from "@/lib/utils/currency";
import { useTenantData } from "./useTenantData";

/** Tenant currency as ISO 4217 numeric code for API requests (e.g. `840` for USD). */
export function useTenantCurrencyNumeric(): string {
  const { tenantData } = useTenantData();
  return toRequestCurrency(tenantData?.currency);
}
